// TO BUILD : npm run build production ; explorer ./build
import React from 'react';

//import bootstrap from 'bootstrap'
// Bootstrap CSS
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "../../node_modules/bootstrap/dist/js/bootstrap.bundle.min";
import '../App.css';

import { IVaderLeague,IVaderPick,IVaderRole,IVaderUser,IVaderWinLoss,IVaderConfigObj} from '../interfaces/vader'
import { IEspnEventWeek} from '../interfaces/espn'



const resultsUrls_2026 = [
  {
    Title:"Pre season results 2025  (TBA)",
    //URL:"https://nfl.vader.zone/preseason-2026-results.jpg"
    URL:"https://nfl.vader.zone/9Feb2026.jpg"
  },
  {
    Title:"Week 1 Reguar season results 2025  (Cory, Josh 11-5)",
    URL:"https://nfl.vader.zone/reg-1-2026.jpg"
  },
  {
    Title:"Week 2 Reguar season results 2025  (Nevaeh 13-3)",
    URL:"https://nfl.vader.zone/reg-2-2026.jpg"
  },
  {
    Title:"Week 3 Reguar season results 2025  (Josh  12-3)",
    URL:"https://nfl.vader.zone/reg-3-2026.jpg"
  },
/*  {
    Title:"Week 4 Reguar season results 2025  (Jen 10-5)",
    URL:"https://nfl.vader.zone/reg-4-2025.jpg"
  },
  {
    Title:"Week 5 Reguar season results 2025  (Jamie 9-5)",
    URL:"https://nfl.vader.zone/reg-5-2025.jpg"
  },
  {
    Title:"Week 6 Reguar season results 2025 (Doley & Jay  11-4)",
    URL:"https://nfl.vader.zone/reg-6-2025.jpg"
  },
  {
    Title:"Week 7 Reguar season results 2025 (Rowdy  13-2)",
    URL:"https://nfl.vader.zone/reg-7-2025.jpg"
  },
  {
    Title:"Week 8 Reguar season results 2025 (Jamie, Nick, Rowdy  10-3)",
    URL:"https://nfl.vader.zone/reg-8-2025.jpg"
  },
  {
    Title:"Week 9 Reguar season results 2025  (Cory, Jamie, Nevaeh, Nick, Josh  10-4)",
    URL:"https://nfl.vader.zone/reg-9-2025.jpg"
  },
  {
    Title:"Week 10 Reguar season results 2025  (Doley  10-4)",
    URL:"https://nfl.vader.zone/reg-10-2025.jpg"
  },
  {
    Title:"Week 11 Reguar season results 2025  (Doley, Jamie, Jen  13-2)",
    URL:"https://nfl.vader.zone/reg-11-2025.jpg"
  },
  {
    Title:"Week 12 Reguar season results 2025 (Matt, Jay  11-3)",
    URL:"https://nfl.vader.zone/reg-12-2025.jpg"
  },
  {
    Title:"Week 13 Reguar season results 2025  (Doley, Jamie, Nevaeh  11-5)",
    URL:"https://nfl.vader.zone/reg-13-2025.jpg"
  },
  {
    Title:"Week 14 Reguar season results 2025  (Josh  9-5)",
    URL:"https://nfl.vader.zone/reg-14-2025.jpg"
  },
  {
    Title:"Week 15 Reguar season results 2025  (Rowdy  12-4)",
    URL:"https://nfl.vader.zone/reg-15-2025.jpg"
  },
  {
    Title:"Week 16 Reguar season results 2025  (Doley & Jen  13-3)",
    URL:"https://nfl.vader.zone/reg-16-2025.jpg"
  },
  ,
  {
    Title:"Week 17 Reguar season results 2025  (Jay & Jose  12-4)",
    URL:"https://nfl.vader.zone/reg-17-2025.jpg"
  },
  {
    Title:"Week 18 Reguar season results 2025  (Mark  12-4)",
    URL:"https://nfl.vader.zone/reg-18-2025.jpg"
  },
  {
    Title:"Regular season results 2025 (Doley 178/272)",
    URL:"https://nfl.vader.zone/reg2025-results.jpg"
  }*/]

const resultsUrls_2025 = [
  {
    Title:"Pre season results 2025  (Matt)",
    URL:"https://nfl.vader.zone/preseason-2025-results.jpg"
  },
  {
    Title:"Week 1 Reguar season results 2025  (Nick 14-2)",
    URL:"https://nfl.vader.zone/reg-1-2025.jpg"
  },
  {
    Title:"Week 2 Reguar season results 2025  (Jay 13-3)",
    URL:"https://nfl.vader.zone/reg-2-2025.jpg"
  },
  {
    Title:"Week 3 Reguar season results 2025  (Nevaeh, Rowdy, Josh  12-4)",
    URL:"https://nfl.vader.zone/reg-3-2025.jpg"
  },
  {
    Title:"Week 4 Reguar season results 2025  (Jen 10-5)",
    URL:"https://nfl.vader.zone/reg-4-2025.jpg"
  },
  {
    Title:"Week 5 Reguar season results 2025  (Jamie 9-5)",
    URL:"https://nfl.vader.zone/reg-5-2025.jpg"
  },
  {
    Title:"Week 6 Reguar season results 2025 (Doley & Jay  11-4)",
    URL:"https://nfl.vader.zone/reg-6-2025.jpg"
  },
  {
    Title:"Week 7 Reguar season results 2025 (Rowdy  13-2)",
    URL:"https://nfl.vader.zone/reg-7-2025.jpg"
  },
  {
    Title:"Week 8 Reguar season results 2025 (Jamie, Nick, Rowdy  10-3)",
    URL:"https://nfl.vader.zone/reg-8-2025.jpg"
  },
  {
    Title:"Week 9 Reguar season results 2025  (Cory, Jamie, Nevaeh, Nick, Josh  10-4)",
    URL:"https://nfl.vader.zone/reg-9-2025.jpg"
  },
  {
    Title:"Week 10 Reguar season results 2025  (Doley  10-4)",
    URL:"https://nfl.vader.zone/reg-10-2025.jpg"
  },
  {
    Title:"Week 11 Reguar season results 2025  (Doley, Jamie, Jen  13-2)",
    URL:"https://nfl.vader.zone/reg-11-2025.jpg"
  },
  {
    Title:"Week 12 Reguar season results 2025 (Matt, Jay  11-3)",
    URL:"https://nfl.vader.zone/reg-12-2025.jpg"
  },
  {
    Title:"Week 13 Reguar season results 2025  (Doley, Jamie, Nevaeh  11-5)",
    URL:"https://nfl.vader.zone/reg-13-2025.jpg"
  },
  {
    Title:"Week 14 Reguar season results 2025  (Josh  9-5)",
    URL:"https://nfl.vader.zone/reg-14-2025.jpg"
  },
  {
    Title:"Week 15 Reguar season results 2025  (Rowdy  12-4)",
    URL:"https://nfl.vader.zone/reg-15-2025.jpg"
  },
  {
    Title:"Week 16 Reguar season results 2025  (Doley & Jen  13-3)",
    URL:"https://nfl.vader.zone/reg-16-2025.jpg"
  },
  ,
  {
    Title:"Week 17 Reguar season results 2025  (Jay & Jose  12-4)",
    URL:"https://nfl.vader.zone/reg-17-2025.jpg"
  },
  {
    Title:"Week 18 Reguar season results 2025  (Mark  12-4)",
    URL:"https://nfl.vader.zone/reg-18-2025.jpg"
  },
  {
    Title:"Regular season results 2025 (Doley 178/272)",
    URL:"https://nfl.vader.zone/reg2025-results.jpg"
  }
]



const resultsUrls_2024 = [
  {
    Title:"Pre season results",
    URL:"https://nfl.vader.zone/Preseason-2024-results.png"
  },
  {
    Title:"Regular season results",
    URL:"https://nfl.vader.zone/RegSeason-2024-results.png"
  },
  {
    Title:"Post season results",
    URL:"https://nfl.vader.zone/Postseason-2024-results.png"
  },
  {
    Title:"Each user pick vs Team count",
    URL:"https://nfl.vader.zone/Team-vs-user-picks.png"
  },
  {
    Title:"Excel data",
    URL:"https://nfl.vader.zone/2024_picks_season.xlsx"
  },
]

export interface IResultsProps{
  debug:boolean;
  //teamsOnBye:IEspnEventWeek | null,
  thisYear:number;
}

export interface IResultsState{
  selectedWeek:string|number|null;
}


export default class PickEmApp_Results extends React.Component<IResultsProps, IResultsState> {
  
  constructor(props: IResultsProps, state:IResultsState) {
    super(props);
    this.state = {
      selectedWeek:null,
    }
  }
  
  public componentDidMount = async(): Promise<void> => {
    if(this.props.debug){console.log("PickEmApp_Results.componentDidMount() => this : ",this);}
  }


  public render(): React.ReactElement<IResultsProps> {
    
    if(this.props.debug){console.log("PickEmApp_Results.render() => this : ",this);}
    {// return <div> <h3>Results for Pre and Regular season - 2024</h3>
    }
     return <div> <h3>Results for {this.props.thisYear}</h3>
     
      
      {
        resultsUrls_2026.map((resultObj,i)=>{
          return <div key={i} className="row">
              <div className="col-1" />
              {resultObj ? <div className="col-10"><a target="_blank" rel="noopener noreferrer" href={resultObj.URL}>{resultObj.Title}</a></div> : <span></span>}
              <div className="col-1" />
          </div>
        })
      }  

      <br />
      <br />
  </div>
  }

}